import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ZeroStepPage } from './zero-step.page';

const routes: Routes = [
  {
    path: '',
    component: ZeroStepPage,
    children: [
      { path: '', redirectTo: 'erro' },
      {
        path: 'concluido',
        loadChildren: () =>
          import('../signature-done/signature-done.module').then(m => m.SignatureDonePageModule)
      },
      {
        path: 'erro',
        loadChildren: () =>
          import('../signature-error/signature-error.module').then(m => m.SignatureErrorPageModule)
      },
      {
        path: ':id/token',
        loadChildren: () => import('../second-step/second-step.module').then(m => m.SecondStepPageModule)
      },
      {
        path: ':id',
        loadChildren: () => import('../first-step/first-step.module').then(m => m.FirstStepPageModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ZeroStepPageRoutingModule {}
